import app_footer_content from '../../widgets/app-footer-content-widget';
import casino_completed_races from '../../widgets/casino-completed-races-widget';
import casino_game_deck from '../../widgets/casino-game-deck-widget';
import casino_game_grid from '../../widgets/casino-game-grid-widget';
import casino_game_info from '../../widgets/casino-game-info-widget';
import casino_game_of_the_week from '../../widgets/casino-game-of-the-week-widget';
import casino_game_slider from '../../widgets/casino-game-slider-widget';
import casino_game_trailer from '../../widgets/casino-game-trailer-widget';
import casino_games_list from '../../widgets/casino-games-list-widget';
import casino_jackpot from '../../widgets/casino-jackpot-widget';
import casino_mosaic from '../../widgets/casino-mosaic-widget';
import casino_my_games from '../../widgets/casino-my-games-widget';
import casino_my_rewards from '../../widgets/casino-my-rewards-widget';
import casino_new_games from '../../widgets/casino-new-games-widget';
import casino_player_games from '../../widgets/casino-player-games-widget';
import casino_races from '../../widgets/casino-races-widget';
import casino_secondary_navigation from '../../widgets/casino-secondary-navigation-widget';
import casino_top_games from '../../widgets/casino-top-games-widget';
import crm from '../../widgets/crm-widget';
import first_wallet from '../../widgets/first-wallet-widget';
import help_bot from '../../widgets/help-bot-widget';
import help_center_article from '../../widgets/help-center-article-widget';
import help_center_category from '../../widgets/help-center-category-widget';
import help_center_home from '../../widgets/help-center-home-widget';
import help_center_search from '../../widgets/help-center-search-widget';
import poker_bespoke_lobby from '../../widgets/poker-bespoke-lobby-widget';
import poker_cash_games from '../../widgets/poker-cash-games-widget';
import poker_home_games from '../../widgets/poker-home-games-widget';
import poker_lobby_template from '../../widgets/poker-lobby-template-widget';
import poker_multi_table_tournaments from '../../widgets/poker-multi-table-tournaments-widget';
import poker_power_path from '../../widgets/poker-power-path-widget';
import poker_single_tournament from '../../widgets/poker-single-tournament-widget';
import poker_spin_and_go from '../../widgets/poker-spin-and-go-widget';
import poker_sunday_million from '../../widgets/poker-sunday-million-widget';
import sports_animal_racing_landing_page from '../../widgets/sports-animal-racing-landing-page-widget';
import sports_animal_racing_meetings from '../../widgets/sports-animal-racing-meetings-widget';
import sports_animal_racing_specials_page from '../../widgets/sports-animal-racing-specials-page-widget';
import sports_ante_post_events from '../../widgets/sports-ante-post-events-widget';
import sports_ante_post_market from '../../widgets/sports-ante-post-market-widget';
import sports_cms_banner from '../../widgets/sports-cms-banner-widget';
import sports_competition_events from '../../widgets/sports-competition-events-widget';
import sports_competition_outrights from '../../widgets/sports-competition-outrights-widget';
import sports_competitions from '../../widgets/sports-competitions-widget';
import sports_event_info from '../../widgets/sports-event-info-widget';
import sports_event_page from '../../widgets/sports-event-page-widget';
import sports_event_type_info from '../../widgets/sports-event-type-info-widget';
import sports_event_type_specials from '../../widgets/sports-event-type-specials-widget';
import sports_featured_filters from '../../widgets/sports-featured-filters-widget';
import sports_featured from '../../widgets/sports-featured-widget';
import sports_golf_matches from '../../widgets/sports-golf-matches-widget';
import sports_historical_bets from '../../widgets/sports-historical-bets-widget';
import sports_home_in_play from '../../widgets/sports-home-in-play-widget';
import sports_home_page from '../../widgets/sports-home-page-widget';
import sports_in_play_events from '../../widgets/sports-in-play-events-widget';
import sports_landing_page from '../../widgets/sports-landing-page-widget';
import sports_match_filtering from '../../widgets/sports-match-filtering-widget';
import sports_menu from '../../widgets/sports-menu-widget';
import sports_my_bets from '../../widgets/sports-my-bets-widget';
import sports_next_races from '../../widgets/sports-next-races-widget';
import sports_page_not_found from '../../widgets/sports-page-not-found-widget';
import sports_promotion_details from '../../widgets/sports-promotion-details-widget';
import sports_promotion_grid from '../../widgets/sports-promotion-grid-widget';
import sports_promotion from '../../widgets/sports-promotion-widget';
import sports_quick_links from '../../widgets/sports-quick-links-widget';
import sports_race_page from '../../widgets/sports-race-page-widget';
import sports_self_excluded_info from '../../widgets/sports-self-excluded-info-widget';
import sports_seo from '../../widgets/sports-seo-widget';
import sports_settings from '../../widgets/sports-settings-widget';
import sports_sport_in_play_events from '../../widgets/sports-sport-in-play-events-widget';
import sports_upcoming_events from '../../widgets/sports-upcoming-events-widget';

/* eslint-disable @typescript-eslint/naming-convention */
export default {
  app_footer_content,
  casino_completed_races,
  casino_game_deck,
  casino_game_grid,
  casino_game_info,
  casino_game_of_the_week,
  casino_game_slider,
  casino_game_trailer,
  casino_games_list,
  casino_jackpot,
  casino_mosaic,
  casino_my_games,
  casino_my_rewards,
  casino_new_games,
  casino_player_games,
  casino_races,
  casino_secondary_navigation,
  casino_top_games,
  crm,
  first_wallet,
  help_bot,
  help_center_article,
  help_center_category,
  help_center_home,
  help_center_search,
  poker_bespoke_lobby,
  poker_cash_games,
  poker_home_games,
  poker_lobby_template,
  poker_multi_table_tournaments,
  poker_power_path,
  poker_single_tournament,
  poker_spin_and_go,
  poker_sunday_million,
  sports_animal_racing_landing_page,
  sports_animal_racing_meetings,
  sports_animal_racing_specials_page,
  sports_ante_post_events,
  sports_ante_post_market,
  sports_cms_banner,
  sports_competition_events,
  sports_competition_outrights,
  sports_competitions,
  sports_event_info,
  sports_event_page,
  sports_event_type_info,
  sports_event_type_specials,
  sports_featured,
  sports_featured_filters,
  sports_golf_matches,
  sports_historical_bets,
  sports_home_in_play,
  sports_home_page,
  sports_in_play_events,
  sports_landing_page,
  sports_match_filtering,
  sports_menu,
  sports_my_bets,
  sports_next_races,
  sports_page_not_found,
  sports_promotion,
  sports_promotion_details,
  sports_promotion_grid,
  sports_quick_links,
  sports_race_page,
  sports_self_excluded_info,
  sports_seo,
  sports_settings,
  sports_sport_in_play_events,
  sports_upcoming_events
};
